// keepr's Consumer Health Data Privacy Policy (KPR-478), as markdown, served at
// /consumer-health-data once the legal pages publish (src/config/legal.js).
//
// NULL UNTIL IT IS FINAL. The draft is outside the repo
// (~/Dropbox/KEEPR/docs/legal-drafts/consumer-health-data-policy.md) and is
// not committed here until the Oregon LLC exists and counsel has reviewed it:
// whatever is in this file ships to every visitor's browser, switch or no
// switch. When it is final, replace `null` with the reviewed text (its `[TBD]`
// and `[VERIFY]` notes resolved and stripped) in a template string.
const CONSUMER_HEALTH_DATA_POLICY = null;

export default CONSUMER_HEALTH_DATA_POLICY;
